<template>
  <div class="ourTeam">
    <div class="section">
      <div class="container is-fluid">
        <div class="tile is-ancestor">
          <div class="tile is-vertical">
            <div class="tile">
              <div class="tile is-parent is-3 is-vertical">
                <div class="columns">
                  <div class="column">
                    <h1 class="deneme">BÜLTEN</h1>
                  </div>
                </div>
              </div>
              <div class="tile is-parent is-vertical">
                <div class="tile is-child  has-text-right is-size-1"><h2></h2></div>
                <div class="tile columns">
                  <div class="column">
                    <h3>KİŞİSEL VERİLERİ KORUMA KURUMU BAŞKANI, KESİLEN İDARİ PARA CEZALARI HAKKINDA BİLGİ VERDİ</h3>

                    <span>Tarih: 02.11.2017</span>
                    <hr>

                    <p>
                      TBMM Plan ve Bütçe Komisyonu'nda Kişisel Verileri Koruma Kurumu’nun (“Kurum”) bütçesi görüşüldü. Görüşmeler esnasında konuşan Kurum Başkanı Faruk Bilir, Kurum’un 2017 yılında 34 şikayet ve 7 ihbar olmak üzere toplam 41 başvuru aldığını, bu başvuruların 19'unun karara bağlandığını ve toplam 125 bin Türk Lirası tutarında idari para cezası kesildiğini açıkladı.</p>
                    <p>
                      Bilir ayrıca Kurum’un 2017 yılı içinde kendi bütçesi olmadığını ve Maliye Bakanlığının yedek ödeneğinden aktarılan 15 milyon Türk Lirası ile bütçe ihtiyaçlarını karşılamaya devam ettiklerini, çalışma ortamı ve personel ihtiyaçlarını karşılamak için 2018 yılında toplam 30 milyon 503 bin Türk Lirası ödenek talep edildiğini de ifade etti. Kurum’un bütçe ihtiyacı sebebiyle 2018 yılında idari para cezalarına ağırlık vermesi bekleniyor.</p>


                  </div>
                </div>
                <div class="tile columns">
                  <div class="column">
                    <h3>
                      KİŞİSEL VERİLERİN SİLİNMESİ, YOK EDİLMESİ VEYA ANONİM HALE GETİRİLMESİ HAKKINDA YÖNETMELİK RESMİ GAZETE’DE YAYIMLANDI</h3>

                    <span>Tarih: 28.10.2017</span>
                    <hr>

                    <p>
                      6698 Sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) madde 7/1 uyarınca; Kanun’a ve ilgili diğer kanunlara uygun olarak işlenmiş olmasına rağmen işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel veriler re’sen veya ilgili kişinin talebi üzerine veri sorumlusu tarafından silinmek, yok edilmek veya anonim hâle getirilmek zorundadır.</p>

                    <p>
                      Kanun madde 7/3 uyarınca; kişisel verilerin silinmesine, yok edilmesine veya anonim hâle getirilmesine ilişkin usul ve esaslar yönetmelikle düzenlenir. Bu kapsamda Kişisel Verileri Koruma Kurumu tarafından düzenlenen Kişisel Verilerin Silinmesi, Yok Edilmesi veya Anonim Hale Getirilmesi Hakkında Yönetmelik (“Yönetmelik”) 28 Ekim 2017 Cumartesi günü Resmi Gazete’de yayımlandı. Yönetmelik, 1 Ocak 2018 tarihinde yürürlüğe girecek ve uygulanmaya başlayacaktır.</p>

                    <p>
                      Yönetmelik, kişisel verilerin talep üzerine silinmesine ilişkin usulü, re’sen periyodik olarak silinmesine ilişkin uyulması gereken zorunlu süreleri, kişisel veri işleme envanteri ve kişisel verileri saklama ve imha politikası düzenleme zorunlulukları gibi kritik hususları içermektedir. Bu kapsamda;</p>

                    <ul>
                      <li>
                        Veri sorumluları, iş süreçlerine bağlı olarak gerçekleştirmekte oldukları kişisel verileri işleme faaliyetlerini; kişisel verileri işleme amaçları, veri kategorisi, aktarılan alıcı grubu ve veri konusu kişi grubuyla ilişkilendirerek oluşturdukları ve kişisel verilerin işlendikleri amaçlar için gerekli olan azami süreyi, yabancı ülkelere aktarımı öngörülen kişisel verileri ve veri güvenliğine ilişkin alınan tedbirleri açıklayarak detaylandırdıkları bir kişisel veri işleme envanteri hazırlamak,
                      </li>
                      <li>
                        Veri Sorumluları Siciline kayıt olmakla yükümlü olan veri sorumluları, kişisel veri işleme envanterine uygun olarak kişisel veri saklama ve imha politikası hazırlamak,
                      </li>
                      <li>
                        Veri sorumluları, kişisel veri işleme envanteri ve politikalarına uygun olarak ve 6 ayı geçmeyecek şekilde periyodik olarak kişisel verileri imha etmek zorundadır.

                      </li>
                    </ul>
                    <p>
                      Sonuç olarak; veri sorumluların hem Kanun’a uyumlu hale gelebilmek hem de Yönetmelik kapsamında düzenlenen kişisel veri işleme envanteri ve kişisel veri saklama ve imha politikalarını hazırlayabilmek için kişisel veri süreçlerinin başından sonuna kadar inceleneceği bir hukuki iç denetimden geçmeleri ihtiyacı ortaya çıkmıştır.</p>

                  </div>
                </div>
                <div class="tile columns">
                  <div class="column">
                    <h3>KİŞİSEL VERİLERİ KORUMA KURUMU’NDAN İLK CEZA</h3>

                    <span>Tarih: 12.10.2017</span>
                    <hr>

                    <p>
                      6698 sayılı Kişisel Verilerin Korunması Kanunu’nun (“Kanun”) yürürlüğe girmesi ile birlikte Kanun tarafından verilen görevleri yerine getirmek üzere, idari ve mali özerkliğe sahip ve kamu tüzel kişiliğini haiz Kişisel Verileri Koruma Kurumu (“Kurum”) kurulmuştu. Başbakanlık bünyesinde kurulan ve merkezi Ankara olan Kurum, faaliyetlerine başladı.</p>

                    <p>
                      Kanun uyarınca en çok merak edilen konuların başında olan idari para cezalarının Kurum tarafından ne zaman düzenleneceği hakkında hem ticari aktörler hem de hukukçular arasında bir bekleyiş bulunmaktaydı.</p>

                    <p>
                      Kurum’dan alınan bilgiye göre; ilk idari para cezası, Kanun madde 12 uyarınca kişisel verilerin güvenliğini sağlama yükümlülüğünü ihlal nedeniyle düzenlendi. Bu kapsamda kişisel veri işleyen özel veya tüzel tüm kişi ve kuruluşların veri güvenliğini sağlamak için tüm gerekli teknik tedbirleri almalarının önemi vurgulanmış oldu.</p>
                  </div>
                </div>
                <div class="tile columns">
                  <div class="column">
                    <h3>KİŞİSEL VERİLERİN KORUNMASI HAKKINDA KANUN’DA DEĞİŞİKLİK</h3>

                    <span>Tarih: 05.10.2017</span>
                    <hr>

                    <p>
                      27 Eylül 2017 tarihli ve 884 sayılı kanun tasarısı (“Tasarı”) ile 6698 sayılı Kişisel Verilerin Korunması Kanunu'nda bir takım değişiklikler yapılması bekleniyor. Tasarının 123 ila 126. maddeleri ile getirilmesi beklenen yenilikler ve düzenlemeler aşağıdaki şekildedir:</p>

                    <ul>
                      <li>
                        Kişisel Verileri Koruma Kurumu (“Kurum”) bünyesinde oluşturulacak Veri Sorumluları Sicili’ne kayıt için ücret alınacağı düzenleniyor. Tasarının madde gerekçesinde İngiltere ve İrlanda gibi ülkelerde de sicile kayıt için ücret talep edildiği ifade ediliyor.
                      </li>  <li>
                      Kurum’un ihtiyacı olan uzman atamalarının yapılması, Kurum bünyesinde hâkim ve savcıların görevlendirilmesi planlanıyor.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tile columns">
                  <div class="column">
                    <h3>AB HUKUKU KAPSAMINDA KİŞİSEL VERİLERİN KORUNMASI VE WEB ÇEREZLERİNİN KULLANIMI</h3>

                    <span>Tarih: 26.12.2014</span>
                    <hr>

                    <p>
                      Internet çerezleri, günümüz internet teknolojisinin işlemesinde önemli bir işlevi bulunmaktadır; ancak bununla birlikte internet kullanıcılarının gizliliğine ilişkin ciddi endişe de uyandırmaktadır. Bu nedenle Avrupa Birliği, internet kullanıcılarının kişisel verilerinin korunması yönündeki beklentilerini karşılamak için bazı web çerezlerinin kullanılabilmesi adına web sitelerinin kullanıcılardan bilgilendirilmiş rıza alınması zorunluluğunu getirdi. Ancak bu rızanın açık rıza veya zımni rıza mı olacağı ve hangi yöntemlerle alınacağı konusunda herhangi bir usul bulunmamaktadır.</p>
                    <p>
                      Dijital dünyada web kullanıcılarının rızasını almak konusunda değişik yöntemler uygulandığı görülmektedir. Bu yöntemlerden bazıları kanunlara uyum konusunda önemli adımlar atarken diğerleri kullanım deneyimini sekteye uğratmamak ve pratikliği ön plana çıkarmak için kanuni yükümlülükler konusunda gri alanlarda yer almaktadır.</p>
                    <p>
                      Rıza alabilmek için kullanılan başlıca metodlar aşağıdaki şekildedir.</p>

                    <ul>
                      <li>
                        açılan ekranlar (splash-screen),
                      </li>  <li>
                      bant uyarılar (banner),
                      </li> <li>
                      sayfa ortasında beliren uyarılar (pop-up),
                      </li><li>
                      aktivasyon butonları ve web tarayıcı varsayılan ayarlarının değiştirilmesi.
                      </li>
                    </ul>
                    <p>Bu yöntemlerden hangisinin seçilmesi gerektiği konusunda net çizgiler bulunmamaktadır ancak hukuki kanaatimiz, web sitesi yöneticilerinin öncelikle web sitelerinde yer alan çerezlerin hangi amaçlarla hangi verileri işlediğini tespit etmeleri ve bilişim hukukçuları ile işbirliği içerisinde web sayfalarını tasarlamalarının gerekli olduğudur.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'bulten',
    data() {
      return {}
    },
    methods: {},
    mounted() {

    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .paddingless {
    padding-left: 0px;
    padding-right: 0px;
  }

  .ourTeam p {
    font-size: 1.2rem;
  }

  ul {
    margin-left: 60px;
    max-width: 50%;
  }

  ul li {
    font-size: 1.2rem;
    color: #1d1d1d;
    list-style: disc;
    padding: 20px 0;
  }

  #app {
    background: #606c96;
  }

  .ourTeam h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .ourTeam h1, .ourTeam h2 {
    position: relative;
    color: #504f50;
    padding-top: 70px;
    font-family: 'SEC', sans-serif;
  }

  .active {
    display: flex;
  }

  p {
    color: black;
    padding: 10px 0;
    font-size:  20px;
    text-align: justify;
  }

  .media-content .title {
    cursor: pointer;
  }

  span {
    font-size: 14px;
    color: #81A716;
    font-feature-settings: on;
  }

  h1 {
    color: azure;
    font-family: 'SEC';
  }

  h3 {
    color: #1d1d1d;
    text-transform: uppercase;
    font-size: 25px;
    font-family: SEC, sans-serif;
    font-weight: 800;
  }

  .tile.columns {
    margin-bottom: 100px;
  }

  .modal .is-one-quarter::after {
    display: none;
  }

  .modal .is-one-quarter {
    padding-right: 27px;
  }

  .modal .is-one-quarter img {
    padding-top: 15px;
  }

  .content:not(:last-child) {
    margin-bottom: 0px;
  }

  .content {
    text-align: left;
  }

  .modal-content {
    width: 950px;
  }

  @media only screen and (max-width: 768px) {
    .ourTeam {
      margin-bottom: 100px;
    }

    .ourTeam h1 {
      font-size: 25px;
      padding-top: 0px;
    }

    div.tile.is-parent.is-3.is-vertical::after {
      content: "";
      position: absolute;
      right: 12%;
      top: 0;
      height: 100%;
      background: unset;
      width: 1px;
    }

    img {
      height: auto;
      max-width: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// bulten.vue?1eba8181